import {Component, OnDestroy, OnInit} from '@angular/core';
import {MasterDataImportService} from '../../services/master-data-import.service';
import {Subscription} from 'rxjs/Subscription';
import {Page} from '../../../../model/page';
import {Title} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';
import * as _ from 'lodash';

@Component({
    selector: 'app-master-data-import-queue',
    templateUrl: './master-data-import-queue.component.html',
    styleUrls: [],
    providers: [
        MasterDataImportService
    ],
    preserveWhitespaces: true
})
export class MasterDataImportQueueComponent implements OnInit, OnDestroy {

    private subscription: Subscription;
    public page = new Page();

    public cols: Array<any>;
    public rows: Array<any>;
    public statusOptions: Array<any>;
    public totalRecords: number;

    public filters: { [key: string]: any; };
    public filtersApplied: boolean;
    public loading: boolean;

    public masterDataImportServiceRef = MasterDataImportService;

    constructor(
        private masterDataImportService: MasterDataImportService,
        private title: Title,
        private toast: ToastrService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 50;
        this.title.setTitle('OES - Master Data Import Queue');
    }

    ngOnInit() {
        this.initValues();
        this.getData();
    }

    initValues() {
        this.cols = [
            { field: 'CU1_NAME', header: 'Customer', visible: true, filter: true, width: 100 },
            { field: 'MDI1_CREATED_ON', header: 'Requested On', visible: true, filter: false, width: 100 },
            { field: 'MDI1_STATUS', header: 'Status', visible: true, filter: true, width: 100 },
            { field: 'MDI1_DETAILS', header: 'Details', visible: true, filter: false, width: 100 }
        ];
        this.rows = [];
        this.statusOptions = this.masterDataImportService.getStatusOptions();
        this.totalRecords = 0;
        this.filters = {};
        this.filtersApplied = false;
        this.loading = false;
    }

    getData() {
        this.loading = true;
        this.subscription = this.masterDataImportService.getItems(this.page).subscribe(result => {
            this.rows = result.data.map(record => {
                record['MDI1_STATUS'] = Number(record['MDI1_STATUS']);
                return record;
            });
            this.totalRecords = result.count;
            this.loading = false;
        }, () => {
            this.toast.error('Request timed out.', 'Service Error');
            this.loading = false;
        });
    }

    refreshClick() {
        this.rows = [];
        this.getData();
    }

    onPage(event) {
        this.page.pageNumber = event.first / event.rows;
        this.getData();
    }

    applyFilters() {
        const filters = _.clone(this.filters);
        for (const filterKey of Object.keys(filters)) {
            if (filters[filterKey] == null || filters[filterKey] === undefined || filters[filterKey] === '') {
                delete filters[filterKey];
            }
        }
        this.filtersApplied = Object.keys(filters).length > 0;
        this.page.filterParams = filters;

        this.page.pageNumber = 0;
        this.getData();
    }

    clearFilters() {
        this.filters = {};
        this.filtersApplied = false;

        this.applyFilters();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    cancelClick() {
        window.history.back();
    }

}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/master-data/master-data-import-queue/master-data-import-queue.component.ts